// extracted by mini-css-extract-plugin
var _1 = "ivhiM";
var _2 = "RuMRX";
var _3 = "P0MqK";
var _4 = "V4z9T";
export { _1 as "cardSliderContent", _2 as "imageSliderContainer", _3 as "textSliderContainer", _4 as "transitionStyle" }
